export default __webpack_public_path__ + "static/media/iphone.37ab0522.svg";